import { render } from "./LifecycleStepper.vue?vue&type=template&id=10389b2c&scoped=true"
import script from "./LifecycleStepper.vue?vue&type=script&lang=js"
export * from "./LifecycleStepper.vue?vue&type=script&lang=js"

import "./LifecycleStepper.vue?vue&type=style&index=0&id=10389b2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10389b2c"]])

export default __exports__